<template>
  <div class="category-wrapper">
    <layout>
      <div slot="content" class="con">
        <div class="left">
          <div
            class="conter"
            :class="index == currentIndex ? 'leftActive' : ''"
            v-for="(item, index) in CategoryList"
            :key="item.category_id"
            @click="jumpTo(item, index)"
          >
            <img
              v-if="index == currentIndex"
              class="FirstBg"
              src="@/assets/img/FirstBg.jpg"
              alt=""
            />
            {{ item.name }}
            <div v-if="item.child">
              <div
                v-for="(it, idx) in item.child"
                @click.stop="test(it, index, idx)"
                :class="it.category_id == childCurrentId ? 'childActive' : ''"
                class="child"
                :key="it.category_id"
              >
                {{ it.name }}
              </div>
            </div>
            <!-- <div class="normal" :class="{ active: activeIndex == index }"></div> -->
          </div>
        </div>
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <div class="middle" ref="listWrapper">
          <div class="list-wrapper">
            <!-- <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              :offset="500"
            > -->
            <div class="cateImg">
              <!-- <img
                :src="CategoryList[CategoryActiveImg].pad_image.file_path"
                v-if="CategoryList.length > 0"
              /> -->
            </div>
            <div class="middle_content">
              <div
                class="item"
                v-for="(items, index) in goodsList"
                :key="index"
                @click="jump(items.goods_id)"
              >
                <div class="img">
                  <img
                    :src="items.image[0].file_path | thumbnail(720, 720)"
                    alt
                  />
                </div>
                <div class="message">
                  <div class="des" style="font-size: 16px">
                    <p>{{ items.goods_name }}</p>
                    <p>产品编号：{{ items.goods_number }}</p>
                    <p>克重(g)：{{ items.sku[0].goods_weight }}</p>
                  </div>
                  <!-- <div v-if="!token" class="price">
                      ￥{{ items.goods_max_price }}
                    </div> -->
                </div>
              </div>
            </div>
            <div class="load">{{ loading ? "加载中..." : "没有更多了" }}</div>
            <!-- </van-list> -->
          </div>
        </div>
        <!-- </van-pull-refresh> -->
      </div>
    </layout>
    <div
      v-if="pagecount >= 2"
      class="page animate__animated animate__fadeInRight"
    >
      <p>{{ page }}</p>
      <p>——</p>
      <p>{{ pagecount }}</p>
    </div>
  </div>
</template>
<script>
import layout from "@/components/layout.vue";
import {
  getCategory,
  sendCategoryBrowseInfo,
  getCategoryChild,
  getList,
  login_mobile
} from "../../api/http.js";
import { animateCSS } from "../../utils/animate.js";
import axios from "axios";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import MouseWheel from "@better-scroll/mouse-wheel";
import "animate.css";
import $ from "jquery";
BScroll.use(Pullup);
BScroll.use(MouseWheel);

export default {
  components: {
    layout
  },
  data() {
    return {
        user_type: '',
      token: "",
      CategoryList: [],
      CategoryActiveImg: 0,
      goodsList: [],
      ids: 0,
      activeIndex: 0,
      category_id: 0,
      itemsize: false,
      isLoading: false,
      loading: false,
      finished: false,
      currentPage: 1,
      pagecount: 1,
      pageY: 680,
      currentIndex: 0,
      childCurrentId: null,
      categoryBrowseInfo:{
        category_id: 0, 
        click_time: 0, 
        view_duration: 0,
      }
    };
  },
  created() {

    if (localStorage.getItem("getCategory_size") != null) {
      this.itemsize = Boolean(
        localStorage.getItem("getCategory_size") === "true"
      );
    }
    this.init(this.ids);
    // this.$nextTick(()=>{
    // this.scroll = new Bscroll(this.$refs.listWrapper, {})
    // })
  },
  mounted() {
    // this.init(this.ids);
    this.scroll();
    this.bscroll.refresh();
  },
  beforeDestroy(){
    this.sendCategoryBrowseInfoToServe()
  },
  watch: {
    goodsList() {
      this.$nextTick(() => {
        this.bscroll.refresh();
        this.bscroll.finishPullUp();
      });
    }
    // currentIndex() {
    //   document.querySelector(".FirstBg").style.opacity = 1;
    // }
  },
  deactivated() {
    this.sendCategoryBrowseInfoToServe()
  },
  activated() {
    this.token = localStorage.getItem("login_token");

    this.categoryBrowseInfo.category_id = this.category_id;
    this.categoryBrowseInfo.click_time = Math.floor(Date.now() / 1000);

    this.user_type = localStorage.getItem("user_type");

    this.bscroll.refresh();
  },
  computed: {
    page: function() {
      if (this.pageY <= 680) {
        return 1;
      } else {
        if (Math.ceil(this.pageY / 1400) >= this.pagecount) {
          return this.pagecount;
        } else {
          return Math.ceil(this.pageY / 1400) + 1;
        }
      }
    }
    // page: function() {
    //   if (this.pageY <= 683) {
    //     return 1;
    //   } else if (this.pageY >= 683 && this.pageY <= 2083) {
    //     return 2;
    //   } else {
    //     if (Math.ceil(this.pageY / 1400) > this.pagecount) {
    //       return this.pagecount;
    //     } else {
    //       return Math.ceil(this.pageY / 1400);
    //     }
    //   }
    // }
  },
  methods: {
    sendCategoryBrowseInfoToServe(newCategorysId){
      let {category_id, click_time, view_duration} = this.categoryBrowseInfo
      view_duration = Math.floor(Date.now() / 1000) - click_time
      let token = localStorage.getItem("login_token")
      if(category_id){
          sendCategoryBrowseInfo(category_id, click_time, view_duration, token)
      }
      if(newCategorysId){
          this.categoryBrowseInfo.category_id = newCategorysId;
          this.categoryBrowseInfo.click_time = Math.floor(Date.now() / 1000);
      }
    },
    test(it, index, idx) {
      console.log(it, index, idx);
      this.currentPage = 1;
      this.category_id = it.category_id;
      this.sendCategoryBrowseInfoToServe(this.category_id)
      this.currentIndex = index;
      this.childCurrentId = it.category_id;
      this.goodsList = [];
      // this.getList(1, "all", true, this.CategoryList[0].category_id, "", "");
      // this.getList(this.currentPage, "all", true, this.category_id, "", "");
      this.getList(this.currentPage, "all", true, this.category_id, "", "");
    },
    scroll() {
      this.bscroll = new BScroll(this.$refs.listWrapper, {
        pullUpLoad: {
          threshold: 500
        },
        maxScrollY: -50,
        mouseWheel: true,
        disableTouch: false,
        disableMouse: false,
        click: true
      });
      this.bscroll.on("pullingUp", () => {
        if (this.user_type!==null && this.user_type!=='general_user' && this.currentPage <= this.pagecount) {
          this.loading = true;
          this.getList(this.currentPage, "all", true, this.category_id, "", "");
        } else {
          this.loading = false;
        }
      });
      this.bscroll.on("scroll", pos => {
        this.pageY = parseInt(Math.abs(pos.y));
      });
    },
    init(ids) {
      getCategoryChild().then(res => {
        this.CategoryList = res.data.list;
        //page,sortType,sortPrice,category_id,search,wxapp_id
        animateCSS(".cateImg", "fadeInDown");

        //初始化时间统计参数
        this.categoryBrowseInfo.category_id = this.CategoryList[0].category_id
        this.categoryBrowseInfo.click_time = Math.floor(Date.now() / 1000);

        this.getList(1, "all", true, this.CategoryList[0].category_id, "", "");
        setTimeout(() => {
          let conter = document.querySelectorAll(".conter");
          let time = 200;
          conter.forEach(item => {
            setTimeout(() => {
              item.style.opacity = 1;
            }, time);
            time += 100;
          });
        }, 500);
      });
    },
    jumpTo(item, index) {
      if (item.child) {
        this.category_id = item.child[0].category_id;
        this.childCurrentId = this.category_id;
      } else {
        this.childCurrentId = null;
        this.category_id = item.category_id;
      }

      this.sendCategoryBrowseInfoToServe(this.category_id)
      this.currentIndex = index;
      this.currentPage = 1;
      this.CategoryActiveImg = index;
      this.activeIndex = index;

      this.$nextTick(() => {
        if ($(".leftActive").children().length > 1) {
          $(".leftActive")
            .children("div")
            .slideToggle(400);
        }
        this.goodsList = [];
        this.getList(1, "all", true, this.category_id, "", "", true);
      });
      // animateCSS(".cateImg", "fadeOutUp");
      // animateCSS(".middle_content", "fadeInDown");
    },
    jump(ids) {
      this.$router.push({
        path: "/details",
        query: {
          //路由传参时push和query搭配使用 ，作用是传递参数
          id: ids
        }
      });
    },
    // onLoad() {
    //   this.currentPage = parseInt(this.currentPage) + 1;
    //   this.getList(
    //     this.currentPage,
    //     "all",
    //     true,
    //     this.category_id,
    //     this.searchresult || ""
    //     // this.tokenr
    //   );
    // },

    getList(
      page,
      sortType,
      sortPrice,
      category_id,
      search,
      token,
      // tags,
      refresh = false
    ) {
      if (refresh) {
        this.finished = false;
        this.goodsList = [];
        animateCSS(".cateImg", "fadeInDown");
      }
      getList(
        this.currentPage,
        sortType,
        sortPrice,
        category_id,
        search,
        this.token
        // tags
      ).then(res => {
        this.bscroll.refresh();
        console.log(res);
        this.goodsList = this.goodsList.concat(res.data.list.data);
        if(process.env.VUE_APP_ISAPP=='true'){
            // this.goodsList.forEach(item=>{
            //     item.image[0].file_path = './models/modelImgs/' + item.image[0].id+'.png'
            // })
            this.goodsList.forEach((item,index)=>{

                        if(item.image){
                            window.electronAPI.isImgExisted(item.image[0].image_id+'.png',index)
                        
                            window.electronAPI.on('isImgExistedRes',(isExisted,itemIndex)=>{
                                if(isExisted=='existed'){
                                    this.goodsList[itemIndex].image[0].file_path = './models/modelImgs/' + this.goodsList[itemIndex].image[0].image_id+'.png'   
                                }
                            })
                        }   
                        
                    })
        }
        this.currentPage = res.data.list.current_page;
        this.pagecount = res.data.list.last_page;
        setTimeout(() => {
          document.querySelectorAll(".item").forEach(item => {
            item.style.opacity = 1;
          });
        }, 200);
        if (page == 1) {
          animateCSS(".middle_content", "fadeInUp");
        }
        if (this.currentPage >= this.pagecount) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.loading = false;
        this.currentPage++;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  p {
    margin: 0;
    line-height: 1;
    font-size: 10px;
    transform: scale(0.83, 0.83);
    &:nth-of-type(1) {
      position: relative;
      top: 3px;
    }
    &:nth-of-type(2) {
      position: relative;
      top: -1px;
    }
    &:nth-of-type(3) {
      position: relative;
      top: -2px;
    }
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ccc;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 1000;
  color: #aaa;
  font-weight: 700;
}
.load {
  height: 100px;
  font-size: 15px;
  text-align: center;
  color: #8b8b8b;
}
.category-wrapper {
  width: 100vw;
  overflow: hidden;
}
/deep/.content_1 {
  position: fixed !important;
}
.con {
  position: relative;
  display: flex;
  padding-left: 139px;
  width: 100vw;
  background: #ececec;
  overflow: hidden;
  // box-sizing: border-box;
  // -webkit-overflow-scrolling: touch;
  // overflow-scrolling: touch;
  .left {
    position: fixed;
    left: 0;
    top: 57px;
    bottom: 0;
    width: 139px;
    line-height: 49px;
    text-align: center;
    background: #fff;
    overflow-y: scroll;
    overflow-x: hidden;
    .conter {
      font-weight: 900;
      opacity: 0;
      font-size: 14px;
      color: #1a1a1a;
      transition: opacity 0.5s;
      position: relative;
      .normal {
        margin: 0px auto;
        width: 30px;
        height: 4px;
        background: #fff;
      }
      .active {
        margin: 0px auto;
        width: 30px;
        height: 4px;
        background: #3e210e;
      }
      .child {
        font-weight: normal;
        line-height: 40px;
        height: 40px;
        font-size: 12px;
        color: #5a5a5a;
      }
    }
    // .leftActive::after {
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   bottom: 0;
    //   right: 0;
    //   z-index: -1;
    //   background: url("~@/assets/img/FirstBg.png") no-repeat;
    //   background-size: 100%;
    // }
    .leftActive {
      color: #fff !important;
      // transition: 0.5s;
      // background: url("~@/assets/img/FirstBg.jpg") no-repeat;
      background-size: 100%;
    }
    .FirstBg {
      // opacity: 0;
      transition: 0.5s;
      position: absolute;
      top: 0;
      left: 0;
      // height: 100%;
      width: 100%;
      z-index: -1;
      height: 50px;
    }
    .FirstBgActive {
      opacity: 1;
      transition: 0.5s;
    }
    .childActive {
      color: #fff !important;
      // transition: 0.5s;
      background: url("~@/assets/img/childBg.jpg") no-repeat;
      background-size: 100% 100%;
    }
  }
  .middle {
    // padding: 8px 9px;
    // box-sizing: border-box;
    height: 100vh;
    overflow: hidden;
    width: calc(100% - 139px);
    // overflow-y: scroll;
    // overflow-x: hidden;
    .van-list {
      width: 100% !important;
    }
    .list-wrapper {
      width: 100%;
    }
    .cateImg {
      display: none;
      width: 100%;
      height: 210px;
      overflow: hidden;
      margin-bottom: 10px;
      border-radius: 4px;
      img {
        width: 100%;
        position: relative;
        transform: translateY(-50%);
        top: 50%;
      }
    }
    .AnimateDelay {
      animation-delay: 500ms;
    }
    .middle_content {
      display: flex;
      flex-wrap: wrap;
      //   justify-content: space-around;
      width: 100%;
      padding-top: 15px;

      .item {
        transition: 0.5s;
        opacity: 0;
        width: 25%;
        height: 270px;
        box-sizing: border-box;
        margin-bottom: 5px;
        overflow: hidden;
        padding-left: 5px;
        .img {
          width: 100%;
          height: 75%;
          background: #000000;
          // border-top-left-radius: 4px;
          // border-top-right-radius: 4px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            position: relative;
            object-fit: cover;
          }
        }
        .message {
          height: 25%;
          padding: 10px 10px;
          color: #3e210e;
          background: rgba(255, 255, 255, 1);
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          overflow: hidden;
          .des {
            p {
              font-size: 10px;
              margin: 0;
            }
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .item:nth-child(odd) {
        // padding-right: 5px;
      }
      .item:nth-child(even) {
        // padding-left: 5px;
      }
    }
  }
  .right {
    position: fixed;
    right: 0;
    top: 44px;
    bottom: 0;
    width: 47px;
    line-height: 49px;
    text-align: center;
    background: #fff;
    .conter {
      font-size: 13px;
    }
    .active {
      background: #3e210e;
    }
  }
}
::-webkit-scrollbar {
       width: 0px;
 }
</style>
